var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsDownFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.65016 12.4V15.6C7.65016 16.2365 7.92375 16.847 8.41075 17.2971C8.89775 17.7471 9.55826 18 10.247 18L13.7094 10.8V2.0001H3.94535C3.52785 1.99574 3.1227 2.13098 2.80456 2.38089C2.48643 2.63081 2.27674 2.97857 2.21414 3.36009L1.0196 10.56C0.981938 10.7894 0.998673 11.0235 1.06864 11.2462C1.13862 11.469 1.26015 11.675 1.42483 11.85C1.5895 12.0251 1.79338 12.1649 2.02234 12.2599C2.2513 12.3548 2.49987 12.4027 2.75081 12.4H7.65016Z",
    fill: "#56957F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 10.0009,
    width: 4.23647,
    height: 8,
    rx: 0.4,
    transform: "rotate(180 19 10.0009)",
    fill: "#56957F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDownFilled);
export default __webpack_public_path__ + "static/media/thumbs_down_filled.7d86c565.svg";
export { ForwardRef as ReactComponent };